import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-224fa53f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }

import {computed} from 'vue';
import {ToggleFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import StatusIcon from '@/components/business/crud/common/StatusIcon.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const value = computed(() => {
  if (props.data[props.propName] === undefined) {
    return {text: '', value: undefined};
  } else if (props.data[props.propName] === true) {
    return {text: props.widget.trueText || "是", value: true};
  } else {
    return {text: props.widget.falseText || "否", value: false};
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (value.value.value !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([value.value.value.toString(), "value"])
        }, [
          _createVNode(StatusIcon, {
            value: value.value.value
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(value.value.text), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})